export default __webpack_public_path__ + "static/media/no-access.5016e156.svg";